import React from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { MyThunkDispatch, RootState } from 'store';
import { fetchRestCountryList } from 'actions/i18n';

import Login from 'screens/components/Login';

import { verifyInviteExists, resendInvite } from 'services/loginService';
import { resendTwoFactor } from 'services/otpService';
import { verifyLinkedRappiUser, VerifyLinkedRappiUserParameters } from 'services/registrationService';

const CreateResellerContainer = () => {
  const dispatch: MyThunkDispatch = useDispatch();

  const { restCountries } = useSelector((state: RootState) => state.i18n);
  const { isLoading } = useSelector((state: RootState) => state.companyConfiguration);


  const fetchCountryCodes = () => dispatch(fetchRestCountryList());
  const verifyInvite = (email: string) => verifyInviteExists(email);
  const verifyLinkedUser = (data: VerifyLinkedRappiUserParameters) => verifyLinkedRappiUser(data);
  const resend = (email: string) => resendInvite(email);
  const resendTwoFactorAuth = (key: string) => resendTwoFactor(key);


  return (
    <Login
      isCreateResaller={true}
      fetchCountryCodes={fetchCountryCodes}
      restCountries={restCountries}
      loadingRestCountries={isLoading}
      verifyInviteExists={verifyInvite}
      verifyLinkedUser={verifyLinkedUser}
      resendInvite={resend}
      resendTwoFactor={resendTwoFactorAuth}
    />
  );
};

export default CreateResellerContainer;
